import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ProductOptionsEffects } from './product-options/product-options.effects';
import * as fromProductOptions from './product-options/product-options.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(fromProductOptions.featureKey, fromProductOptions.reducer),
    EffectsModule.forFeature([ProductOptionsEffects]),
  ],
})
export class ProductOptionsStateModule {}
